import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface Lang {
  code: string;
  label: string;
}
@Injectable()
export class TranslateService {
  private isBrowser: boolean;
  private initialized = false;
  private languages: Lang[] = [];

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private router: Router,
    private location: Location
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe(() => this.syncLanguageFromUrl());
    }
  }

  init(languages: Lang[]) {
    if (!this.isBrowser || this.initialized) return;

    this.languages = languages;
    this.initialized = true;
    if (!this.getLangFromUrl()) return;
    // this.prepareGoogleCookies();
    this.injectGoogleScript();

  }

  // private prepareGoogleCookies() {
  //   const lang = new URLSearchParams(window.location.search).get('lang');
  //   if (lang) this.setCookie(lang);
  // }

  private injectGoogleScript() {
    if (document.getElementById('google-translate-script')) return;

    (window as any).googleTranslateElementInit = () => {
      if (!(window as any).google?.translate) return;

      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: this.languages.map(l => l.code).join(','),
          autoDisplay: false
        },
        'google_translate_element'
      );
      setTimeout(() => this.removeBodyInlineStyles(), 100);

      setTimeout(()=>{
        
      },3000)
      this.updateDropdownFromUrl();
     
    };

    const script = document.createElement('script');
    script.id = 'google-translate-script';
    script.src =
      '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';

    script.onerror = () => {
      console.warn('Google Translate failed to load');
    };

    document.head.appendChild(script);
  }

  private removeBodyInlineStyles(): void {
    const body = document.body;
    if (body?.hasAttribute('style')) {
      body.removeAttribute('style');
    }
  }

//   setLanguage(lang: string) {
//     if (!this.isBrowser) return;

//     this.setCookie(lang);

//     const url = new URL(window.location.href);
//     url.searchParams.set('lang', lang);
//     window.history.replaceState({}, '', url.toString());

//     setTimeout(() => {
//       const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;
//       if (select) {
//         select.value = lang;
//         select.dispatchEvent(new Event('change'));
//       }
//     }, 1000);
//   }

setLanguage(lang: string) {
    if (!this.isBrowser) return;
  
    const currentLang =
      new URLSearchParams(window.location.search).get('lang') || 'en';
  
    // 🛑 STOP if same language
    if (currentLang === lang) {
      return;
    }
  
    // Save for Google Translate
    // this.setCookie(lang);
  
    // Build new URL
    const url = new URL(window.location.href);
    url.searchParams.set('lang', lang);
  
    // 🔁 Reload ONCE
    window.location.href = url.toString();
  }
  

  private updateDropdownFromUrl() {
    const lang = new URLSearchParams(window.location.search).get('lang');
    // if (!lang || lang === 'en') return; // default English
  
    if (!lang) return;
    let tries = 0;
    const interval = setInterval(() => {
      const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;
  
      if (select) {
        // Check if the option exists in the dropdown
        const optionExists = Array.from(select.options).some(opt => opt.value === lang);
  
        if (optionExists) {
          // Set value and trigger change
          select.value = lang;
          select.dispatchEvent(new Event('change'));
  
          // ✅ Only clear interval once language is successfully set
          clearInterval(interval);
        }
      }
  
      if (++tries > 20) {
        // Stop polling after ~5 seconds even if not found
        clearInterval(interval);
      }
    }, 250);
  }
  
  


  private syncLanguageFromUrl() {
    const lang = new URLSearchParams(window.location.search).get('lang');
    if (!lang) return;

    const valid = this.languages.some(l => l.code === lang);
    if (valid) this.setLanguage(lang);
  }

  getLangFromUrl(): string | null {
    if (!this.isBrowser) return null;
    return new URLSearchParams(window.location.search).get('lang');
  }
}
